import { useContext } from 'react'

import ProctoringContext from '../../providers/ProctoringProvider'

const useProctoring = () => {
    return useContext(ProctoringContext)
}

export default useProctoring
